import * as sentry from '../../src/utils/sentry'
import { IDB_locationTimelineEventRead, IDB_locationTimelineEventsWrite } from '../IDB/IDB.table.locationTimelineEvent'
import type { NReports } from './Rpts.types'
import type { Type_TTimelineEvent } from '../Type/Type.hive'

export async function Rpts_makeLocationTimelineEventRedundant(report: NReports.INewIntermediateReport) {
    try {
        let timeline = await IDB_locationTimelineEventRead(report.location)

        if (timeline === undefined) {
            timeline = { events: [] as Type_TTimelineEvent[], id: report.location }
        }

        timeline.events.forEach((event) => {
            // Find all report-uploading events for this report id
            if (event.type === 'report-uploading' && event.item.reportId === report.reportId) {
                // Add redundant flag so that it is deleted
                event.meta = {
                    redundant: true,
                    localOnly: true,
                }
            }

            return event
        })

        await IDB_locationTimelineEventsWrite([timeline])
    } catch (error) {
        sentry.err(error, { tags: { context: 'Failed to update timeline events' } })
    }
}
